module.exports = __webpack_public_path__ + "img/07.65e84c6d.jpg";